/** First path segment after `/uploaded-products/` (vendor folder), if present. */
export const extractVendorFromMediaUrl = (url) => {
  const s = String(url || "");
  const marker = "/uploaded-products/";
  const i = s.indexOf(marker);
  if (i < 0) return "";
  const rest = s.slice(i + marker.length);
  const seg = rest.split("/").filter(Boolean)[0];
  if (!seg) return "";
  try {
    return decodeURIComponent(seg);
  } catch {
    return seg;
  }
};

/**
 * Prefer explicit vendor id; otherwise derive from first URL that contains `/uploaded-products/`.
 * @param {string} vendorId
 * @param {string[]} urlCandidates
 */
export const resolveVendorKeyForBadge = (vendorId, urlCandidates = []) => {
  const direct = String(vendorId || "").trim();
  if (direct) return direct;
  const list = Array.isArray(urlCandidates) ? urlCandidates : [];
  for (let i = 0; i < list.length; i += 1) {
    const fromUrl = extractVendorFromMediaUrl(String(list[i] || ""));
    if (fromUrl) return fromUrl;
  }
  return "";
};

const B32 = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

/** Opaque vendor code for UI (same internal key → same code; not an email/name). */
export const formatVendorBadgeLabel = (vendorKey) => {
  const raw = String(vendorKey || "").trim();
  if (!raw) return "";
  let h = 0x811c9dc5;
  for (let i = 0; i < raw.length; i += 1) {
    h ^= raw.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  h >>>= 0;
  let out = "";
  let x = h;
  for (let i = 0; i < 6; i += 1) {
    out += B32[x % 32];
    x = (Math.floor(x / 32) + (i + 1) * 0x9e3779b9) >>> 0;
  }
  return `VC-${out}`;
};

/** Product SKU for badges (trim; falls back to id). Not hashed — catalog identifier. */
export const formatSkuBadgeText = (sku, idFallback = "") => {
  const sRaw = sku != null && String(sku).trim() !== "" ? String(sku).trim() : "";
  const idRaw = idFallback != null && String(idFallback).trim() !== "" ? String(idFallback).trim() : "";
  const raw = sRaw || idRaw;
  if (!raw) return "";
  return raw.length > 22 ? `${raw.slice(0, 20)}…` : raw;
};
